
const CAT_LOGOS = {
  ufc: `<svg width="40" height="40" viewBox="0 0 72 72" fill="none"><rect x="8" y="28" width="56" height="32" rx="1" fill="#1a0a00" stroke="#E8B84B" stroke-width="1"/><rect x="14" y="32" width="44" height="24" rx="1" fill="#2a1200" stroke="#E8B84B" stroke-width="0.5" opacity="0.5"/><rect x="6" y="22" width="5" height="38" rx="1" fill="#333" stroke="#E8B84B" stroke-width="0.8"/><rect x="61" y="22" width="5" height="38" rx="1" fill="#333" stroke="#E8B84B" stroke-width="0.8"/><circle cx="8.5" cy="22" r="3.5" fill="#cc2200" stroke="#E8B84B" stroke-width="0.6"/><circle cx="63.5" cy="22" r="3.5" fill="#cc2200" stroke="#E8B84B" stroke-width="0.6"/><circle cx="8.5" cy="60" r="3.5" fill="#cc2200" stroke="#E8B84B" stroke-width="0.6"/><circle cx="63.5" cy="60" r="3.5" fill="#cc2200" stroke="#E8B84B" stroke-width="0.6"/><line x1="12" y1="24" x2="60" y2="24" stroke="#E8B84B" stroke-width="1.8" opacity="0.9"/><line x1="12" y1="28" x2="60" y2="28" stroke="#E8B84B" stroke-width="1.4" opacity="0.65"/><line x1="12" y1="32" x2="60" y2="32" stroke="#E8B84B" stroke-width="1" opacity="0.4"/></svg>`,
  futbol: `<svg width="40" height="40" viewBox="0 0 72 72" fill="none"><circle cx="36" cy="36" r="28" fill="#0a0a12" stroke="#E8B84B" stroke-width="1.2"/><polygon points="36,20 46,27 43,39 29,39 26,27" fill="#E8B84B" opacity="0.85"/><polygon points="36,20 46,27 50,16 40,10 29,12" fill="none" stroke="#E8B84B" stroke-width="0.8" opacity="0.5"/><polygon points="46,27 50,38 60,33 58,22 50,16" fill="none" stroke="#E8B84B" stroke-width="0.8" opacity="0.5"/><polygon points="43,39 50,38 55,48 46,54 38,50" fill="none" stroke="#E8B84B" stroke-width="0.8" opacity="0.5"/><polygon points="29,39 38,50 30,55 22,49 23,39" fill="none" stroke="#E8B84B" stroke-width="0.8" opacity="0.5"/><polygon points="26,27 23,39 14,36 14,24 22,19" fill="none" stroke="#E8B84B" stroke-width="0.8" opacity="0.5"/></svg>`,
  motor: `<svg width="40" height="40" viewBox="0 0 72 72" fill="none"><path d="M10,38 L14,30 L22,28 L30,26 L42,26 L52,28 L60,32 L62,38 L58,40 L48,40 L42,42 L28,42 L18,40 Z" fill="#111" stroke="#E8B84B" stroke-width="1.2"/><path d="M30,26 L33,20 L42,20 L45,26" fill="#0a0a0a" stroke="#E8B84B" stroke-width="1"/><path d="M10,38 L6,38 L5,40 L8,42 L14,40" fill="#111" stroke="#E8B84B" stroke-width="1"/><path d="M60,32 L66,30 L67,36 L62,36" fill="#111" stroke="#E8B84B" stroke-width="1"/><circle cx="18" cy="42" r="7" fill="#0d0d0d" stroke="#E8B84B" stroke-width="1.5"/><circle cx="18" cy="42" r="1.2" fill="#E8B84B" opacity="0.6"/><circle cx="52" cy="42" r="8" fill="#0d0d0d" stroke="#E8B84B" stroke-width="1.5"/><circle cx="52" cy="42" r="1.5" fill="#E8B84B" opacity="0.6"/><path d="M32,26 Q36,22 40,26" fill="none" stroke="#E8B84B" stroke-width="1.5"/></svg>`,
  deporte: `<svg width="40" height="40" viewBox="0 0 72 72" fill="none"><circle cx="36" cy="36" r="28" fill="#7a2e00" stroke="#1a0a00" stroke-width="0.5"/><path d="M36,8 Q44,20 44,36 Q44,52 36,64" fill="none" stroke="#111" stroke-width="2.5"/><path d="M36,8 Q28,20 28,36 Q28,52 36,64" fill="none" stroke="#111" stroke-width="2.5"/><path d="M8,36 Q20,28 36,28 Q52,28 64,36" fill="none" stroke="#111" stroke-width="2.5"/><path d="M8,36 Q20,44 36,44 Q52,44 64,36" fill="none" stroke="#111" stroke-width="2.5"/><circle cx="36" cy="36" r="28" fill="none" stroke="#1a0a00" stroke-width="1.5"/></svg>`
};
const VISUALS = {
  // COMBAT SPORTS
  'Octagon Fire':       'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&q=80&fit=crop',
  "Champion's Glory":  'https://images.unsplash.com/photo-1549476464-37392f717541?w=600&q=80&fit=crop',
  'Iron Fist':          'https://images.unsplash.com/photo-1530057521424-7e5175f3d252?w=600&q=80&fit=crop',
  'Fight Night':        'https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?w=600&q=80&fit=crop',
  'The Octagon':        'https://images.unsplash.com/photo-1591117207239-788bf8de6c3b?w=600&q=80&fit=crop',
  'Warrior Code':       'https://images.unsplash.com/photo-1504450758481-7338eba7524a?w=600&q=80&fit=crop',

  // FOOTBALL
  'Golden Boot':        'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=600&q=80&fit=crop',
  'Stadium Nights':     'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=600&q=80&fit=crop',
  'Last Minute':        'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?w=600&q=80&fit=crop',
  'The Beautiful Game': 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=600&q=80&fit=crop',
  'Ultras':             'https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=600&q=80&fit=crop',
  'Class of Legends':   'https://images.unsplash.com/photo-1606925797300-0b35e9d1794e?w=600&q=80&fit=crop',

  // MOTOR SPORTS
  'Full Throttle':      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80&fit=crop',
  'JDM Legend':         'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=600&q=80&fit=crop',
  'Podium Rush':        'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=600&q=80&fit=crop',
  'Apex Hunter':        'https://images.unsplash.com/photo-1541447271487-09612b3f49f7?w=600&q=80&fit=crop',
  'Night Rally':        'https://images.unsplash.com/photo-1504215680853-026ed2a45def?w=600&q=80&fit=crop',
  'Grid Position':      'https://images.unsplash.com/photo-1659618235949-4944e5f83b9f?w=600&q=80&fit=crop',

  // BASKETBALL
  'Slam Dunk':          'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=600&q=80&fit=crop',
  'Court King':         'https://images.unsplash.com/photo-1504450874802-0ba2bcd9b5ae?w=600&q=80&fit=crop',
  'Championship':       'https://images.unsplash.com/photo-1519861531473-9200262188bf?w=600&q=80&fit=crop',
  'Crossover':          'https://images.unsplash.com/photo-1577471488278-16eec37ffcc2?w=600&q=80&fit=crop',
  'Nothing But Net':    'https://images.unsplash.com/photo-1607627000458-210e8d2bdb1d?w=600&q=80&fit=crop',
  'Fast Break':         'https://images.unsplash.com/photo-1598136490929-292a0a7890c2?w=600&q=80&fit=crop',
};

function getVisual(name) {
  const url = VISUALS[name];
  if (url) {
    return `<img src="${url}" alt="${name}" style="width:100%;height:100%;object-fit:cover;transition:transform 0.5s cubic-bezier(0.34,1.56,0.64,1)" loading="lazy" onerror="this.style.display='none'">`;
  }
  return `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#141414"><span style="font-family:DM Mono,monospace;font-size:0.6rem;color:#333;letter-spacing:2px">${name.toUpperCase()}</span></div>`;
}

/* ── DATA ── */
const CATS = {
  ufc: {
    id:'ufc', ico:'🥊', name:'Combat Sports', full:'Combat Sports Wallpapers',
    sub:'UFC · MMA · Boxing', desc:'Raw power, elite fighters, iconic moments. High resolution digital art for combat sports fans.',
    glow:'rgba(232,100,50,0.08)',
    products:[
      {name:'Octagon Fire',desc:'4K digital art with fire effects. Dark background, intense atmosphere. PNG + printable PDF.',badge:'hot'},
      {name:"Champion's Glory",desc:'Minimalist fighter silhouette on a stadium background. Powerful and clean.',badge:''},
      {name:'Iron Fist',desc:'Boxing legend tribute. Black & gold cinematic style. Desktop + mobile wallpaper.',badge:'new'},
      {name:'Fight Night',desc:'Pre-fight walkout atmosphere captured in dramatic digital art. All formats.',badge:'hot'},
      {name:'The Octagon',desc:'Top-down octagon composition. Geometric minimalist design in gold and black.',badge:''},
      {name:'Warrior Code',desc:'Motivational martial arts poster. Bold typography with warrior aesthetic.',badge:'new'},
    ]
  },
  futbol: {
    id:'futbol', ico:'⚽', name:'Football', full:'Football Wallpapers',
    sub:'Clubs · Legends · Moments', desc:'From iconic stadiums to legendary goals. Premium football digital art for every fan.',
    glow:'rgba(50,200,100,0.07)',
    products:[
      {name:'Golden Boot',desc:'Premium retro poster style. Perfect for printing up to A1. 5 formats included.',badge:'new'},
      {name:'Stadium Nights',desc:'Epic stadium atmosphere at night. Cinematic light rays. Desktop + mobile.',badge:'hot'},
      {name:'Last Minute',desc:'Dramatic goal moment captured in digital art. Vibrant colors, instant download.',badge:''},
      {name:'The Beautiful Game',desc:'Celebrating the global spirit of football. Artistic interpretation in bold colors.',badge:'new'},
      {name:'Ultras',desc:'Terrace culture tribute. Smoke, flags and passion captured in poster art.',badge:'hot'},
      {name:'Class of Legends',desc:'Retro tribute to legendary players. Vintage newspaper style, gold accents.',badge:''},
    ]
  },
  motor: {
    id:'motor', ico:'🏎️', name:'Motor Sports', full:'Motor Sports Wallpapers',
    sub:'F1 · Rally · JDM', desc:'Speed, precision and pure adrenaline. Digital art for motorsport and car culture enthusiasts.',
    glow:'rgba(232,184,75,0.07)',
    products:[
      {name:'Full Throttle',desc:'Cinematic F1 composition. Vertical and horizontal versions. Wallpaper + print ready.',badge:'exc'},
      {name:'JDM Legend',desc:'Japanese classic in neon night style. Perfect for 4K desktop wallpaper.',badge:'new'},
      {name:'Podium Rush',desc:'Race podium celebration art. Bold typography and dynamic composition.',badge:''},
      {name:'Apex Hunter',desc:'Technical side of motorsport. Engineered beauty in detailed digital poster.',badge:'new'},
      {name:'Night Rally',desc:'Rally car slicing through the darkness. Motion blur, gravel, raw power.',badge:'hot'},
      {name:'Grid Position',desc:'Lights out and away we go. Starting grid atmosphere in dramatic art.',badge:''},
    ]
  },
  deporte: {
    id:'deporte', ico:'🏀', name:'Basketball', full:'Basketball Wallpapers',
    sub:'NBA · Legends · Culture', desc:'Dunks, courts and championships. Premium basketball digital art inspired by the greatest game.',
    glow:'rgba(80,140,255,0.07)',
    products:[
      {name:'Slam Dunk',desc:'Basketball urban art with vibrant colors. Mobile and PC wallpaper included.',badge:'hot'},
      {name:'Court King',desc:'Legendary player tribute in street art style. High contrast, premium quality.',badge:'new'},
      {name:'Championship',desc:'Trophy moment in cinematic art. Gold and dark color palette. All formats.',badge:''},
      {name:'Crossover',desc:'Explosive dribble freeze-frame. Dynamic composition, electric color palette.',badge:'new'},
      {name:'Nothing But Net',desc:'Pure swish. Minimalist net and ball in perfect harmony. Clean poster art.',badge:'hot'},
      {name:'Fast Break',desc:'Full court fast break captured at peak moment. Speed and determination.',badge:''},
    ]
  }
};

const ALL_PRODUCTS = Object.values(CATS).flatMap(c=>c.products.map(p=>({...p,catId:c.id,catName:c.name})));

/* ── NAVIGATION ── */
function goHome(){
  showPage('home');
  window.scrollTo({top:0,behavior:'smooth'});
}

function goPage(catId){
  if(catId==='all'){
    buildAllPage();
  } else {
    buildCatPage(catId);
  }
  showPage('category');
  window.scrollTo({top:0,behavior:'instant'});
}

function showPage(which){
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));
  document.getElementById('page-'+which).classList.add('active');
}

/* ── BUILD CATEGORY PAGE ── */
function buildCatPage(catId){
  const cat = CATS[catId];
  const others = Object.values(CATS).filter(c=>c.id!==catId);

  // Hero
  document.getElementById('cat-hero').innerHTML=`
    <div class="cat-page-hero">
      <div class="cat-page-bg" style="background:radial-gradient(ellipse 80% 80% at 80% 60%,${cat.glow},transparent 70%)"></div>
      <div class="cat-page-grid-lines"></div>
      <div class="cat-page-inner">
        <div class="cat-breadcrumb" onclick="goHome()">Back to all categories</div>
        <div class="cat-page-tag">${cat.ico} ${cat.sub}</div>
        <h1 class="cat-page-h1"><em>${cat.full}</em></h1>
        <p class="cat-page-desc">${cat.desc}</p>
        <div class="cat-page-count">${cat.products.length} designs available — Instant download</div>
      </div>
    </div>`;

  // Products
  document.getElementById('cat-grid').innerHTML = cat.products.map((p,i)=>`
    <div class="pcard" style="${i%3===2?'border-right:none':''}">
      <div class="pcard-img" style="height:260px">
        ${getVisual(p.name)}
        <div class="overlay-hover"></div>
        ${p.badge==='hot'?'<span class="bdg hot">Hot</span>':p.badge==='new'?'<span class="bdg new-b">New</span>':p.badge==='exc'?'<span class="bdg exc">Exclusive</span>':''}
      </div>
      <div class="pcard-body">
        <h3 class="pcard-name">${p.name}</h3>
        <p class="pcard-desc">${p.desc}</p>
        <div class="pcard-foot">
          <div class="pcard-price">5,99€ <small>digital</small></div>
          <button class="add-btn" onclick="addCart('${p.name}','${cat.ico}','${cat.name}')">Add to cart</button>
        </div>
      </div>
    </div>`).join('');

  // More categories
  document.getElementById('more-cats-section').innerHTML=`
    <div class="more-cats-hdr">
      <h3>Explore more categories</h3>
      <span onclick="goHome()">View all →</span>
    </div>
    <div class="more-cats-grid">
      ${others.map(o=>`
        <div class="more-cat" onclick="goPage('${o.id}')">
          <div class="more-cat-ico">${CAT_LOGOS[o.id]||o.ico}</div>
          <div>
            <div class="more-cat-name">${o.full}</div>
            <div class="more-cat-sub">${o.sub}</div>
          </div>
          <span class="more-cat-arr">→</span>
        </div>`).join('')}
    </div>`;

  // Reveal animations
  setTimeout(()=>{
    document.querySelectorAll('#page-category .pcard').forEach((el,i)=>{
      el.style.opacity='0';el.style.transform='translateY(20px)';
      el.style.transition=`opacity 0.5s ease ${i*0.07}s, transform 0.5s ease ${i*0.07}s`;
      setTimeout(()=>{el.style.opacity='1';el.style.transform='translateY(0)'},50);
    });
  },100);
}

function buildAllPage(){
  const catId='all';
  document.getElementById('cat-hero').innerHTML=`
    <div class="cat-page-hero">
      <div class="cat-page-bg" style="background:radial-gradient(ellipse 80% 80% at 70% 50%,rgba(232,184,75,0.05),transparent 70%)"></div>
      <div class="cat-page-grid-lines"></div>
      <div class="cat-page-inner">
        <div class="cat-breadcrumb" onclick="goHome()">Back to home</div>
        <div class="cat-page-tag">⚡ All categories</div>
        <h1 class="cat-page-h1"><em>All Wallpapers</em></h1>
        <p class="cat-page-desc">Browse the complete collection of high resolution sports wallpapers and posters. Pay once, download instantly.</p>
        <div class="cat-page-count">${ALL_PRODUCTS.length} designs available — Instant download</div>
      </div>
    </div>`;

  document.getElementById('cat-grid').innerHTML = ALL_PRODUCTS.map((p,i)=>`
    <div class="pcard" style="${i%3===2?'border-right:none':''}">
      <div class="pcard-img" style="height:260px">
        ${getVisual(p.name)}
        <div class="overlay-hover"></div>
        ${p.badge==='hot'?'<span class="bdg hot">Hot</span>':p.badge==='new'?'<span class="bdg new-b">New</span>':p.badge==='exc'?'<span class="bdg exc">Exclusive</span>':''}
      </div>
      <div class="pcard-body">
        <h3 class="pcard-name">${p.name}</h3>
        <p class="pcard-desc">${p.desc}</p>
        <div class="pcard-foot">
          <div class="pcard-price">5,99€ <small>digital</small></div>
          <button class="add-btn" onclick="addCart('${p.name}','⚡','${p.catName}')">Add to cart</button>
        </div>
      </div>
    </div>`).join('');

  document.getElementById('more-cats-section').innerHTML='';
  setTimeout(()=>{
    document.querySelectorAll('#page-category .pcard').forEach((el,i)=>{
      el.style.opacity='0';el.style.transform='translateY(20px)';
      el.style.transition=`opacity 0.5s ease ${i*0.04}s, transform 0.5s ease ${i*0.04}s`;
      setTimeout(()=>{el.style.opacity='1';el.style.transform='translateY(0)'},50);
    });
  },100);
}

/* ── CART ── */
let cart=[];
function addCart(name,ico,cat,price=5.99){
  if(cart.find(i=>i.name===name)){showToast('Already in cart');return}
  cart.push({name,ico,cat,price});updateCart();showToast('✓ '+name+' added');openCart();
}
function removeCart(idx){cart.splice(idx,1);updateCart()}
function updateCart(){
  document.getElementById('cart-badge').textContent=cart.length;
  const el=document.getElementById('cart-items'),bot=document.getElementById('cart-bot');
  if(!cart.length){el.innerHTML='<div class="cart-empty">Your cart is empty</div>';bot.style.display='none';return}
  bot.style.display='block';
  el.innerHTML=cart.map((item,i)=>`
    <div class="ci">
      <div class="ci-ico">${item.ico}</div>
      <div class="ci-info"><div class="ci-name">${item.name}</div><div class="ci-cat">${item.cat}</div></div>
      <div class="ci-price">${item.price.toFixed(2)}€</div>
      <button class="ci-rm" onclick="removeCart(${i})">✕</button>
    </div>`).join('');
  document.getElementById('cart-total').textContent=cart.reduce((s,i)=>s+i.price,0).toFixed(2)+'€';
}
function openCart(){document.getElementById('cart').classList.add('open');document.getElementById('overlay').classList.add('on');document.body.style.overflow='hidden'}
function closeCart(){document.getElementById('cart').classList.remove('open');document.getElementById('overlay').classList.remove('on');document.body.style.overflow=''}
function showToast(m){const t=document.getElementById('toast');t.textContent=m;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2800)}

/* ── SCROLL REVEAL ── */
const ro=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible')})},{threshold:0.1});
document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

/* ── CAT TILE ENTRANCE ── */
const catObs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('entered');catObs.unobserve(e.target)}});
},{threshold:0.15});
document.querySelectorAll('.cat-tile').forEach(el=>catObs.observe(el));

/* ── NAV SCROLL ── */
window.addEventListener('scroll',()=>{document.getElementById('nav').style.borderBottomColor=window.scrollY>40?'#222':'var(--line)'});

// Shopify AJAX cart integration
function addToCart(variantId, title, cat) {
  fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
  .then(r => r.json())
  .then(() => { showToast('✓ ' + title + ' added'); refreshCart(); openCart(); })
  .catch(() => showToast('Error adding to cart'));
}

function refreshCart() {
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.getElementById('cart-badge').textContent = cart.item_count;
    renderCart(cart);
  });
}

function renderCart(cart) {
  const el = document.getElementById('cart-items');
  const bot = document.getElementById('cart-bot');
  if (!cart.items.length) {
    el.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
    bot.style.display = 'none'; return;
  }
  bot.style.display = 'block';
  el.innerHTML = cart.items.map((item,i) => `
    <div class="ci">
      <div class="ci-ico">${item.featured_image ? `<img src="${item.featured_image.url}" style="width:100%;height:100%;object-fit:cover">` : '🖼️'}</div>
      <div class="ci-info"><div class="ci-name">${item.title}</div><div class="ci-cat">${item.variant_title || 'Digital'}</div></div>
      <div class="ci-price">${(item.price/100).toFixed(2)}€</div>
      <button class="ci-rm" onclick="removeFromCart('${item.key}')">✕</button>
    </div>`).join('');
  document.getElementById('cart-total').textContent = (cart.total_price/100).toFixed(2) + '€';
}

function removeFromCart(key) {
  fetch('/cart/change.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: 0})
  }).then(r => r.json()).then(cart => { document.getElementById('cart-badge').textContent = cart.item_count; renderCart(cart); });
}

document.addEventListener('DOMContentLoaded', refreshCart);
